<template>
  <div class="other_page">
    <Head class="head_box"></Head>
    <!-- <el-alert
      class="information"
      type="warning"
      effect="dark"
      :closable="false"
      center
    >
      <div slot="title" class="alert-title">
        <span class="scale-text"
          >重磅消息：异形纸卡新上线，询价下单有惊喜！</span
        >
      </div>
    </el-alert> -->
    <div class="login_box">
      <div class="logo" @click="toHome">
        <img src="../../assets/img/fhlogo.png" class="img" />
      </div>
    </div>
    <div class="main_box">
      <div class="menu_box banner_box">
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          text-color="#000000"
          active-text-color="#ffffff"
          popper-append-to-body
          :unique-opened="true"
          @select="toSelectMenu"
        >
          <el-submenu index="1" class="menu_item" v-if="$store.state.userInfo">
            <template slot="title">
              <span>报价下单</span>
            </template>
            <el-menu-item index="1-1" class="menu_item"
              >合版不干胶</el-menu-item
            >
            <el-menu-item index="1-2" class="menu_item"
              >专版不干胶</el-menu-item
            >
            <el-menu-item index="1-3" class="menu_item">卷装标签</el-menu-item>
            <el-menu-item index="1-4" class="menu_item">特殊卷标</el-menu-item>
            <el-menu-item index="1-5" class="menu_item"
              >数码不干胶</el-menu-item
            >
          </el-submenu>
          <el-submenu index="6" class="menu_item" v-if="$store.state.userInfo">
            <template slot="title">
              <span>我的订单</span>
            </template>
            <el-menu-item index="6-1" class="menu_item">管理中心</el-menu-item>
            <el-menu-item index="6-2" class="menu_item">订单管理</el-menu-item>
            <el-menu-item index="6-3" class="menu_item">财务明细</el-menu-item>
            <el-menu-item index="6-4" class="menu_item">会员信息</el-menu-item>
            <el-menu-item index="6-5" class="menu_item"
              >授权书管理</el-menu-item
            >
            <el-menu-item index="6-6" class="menu_item"
              >发票抬头管理</el-menu-item
            >
            <!-- <el-menu-item index="6-7" class="menu_item">发票管理</el-menu-item> -->
            <el-menu-item index="6-8" class="menu_item">修改密码</el-menu-item>
            <el-menu-item index="6-9" class="menu_item">预存</el-menu-item>
            <el-menu-item index="6-0" class="menu_item">售后记录</el-menu-item>
            <el-menu-item index="6-11" class="menu_item">领券中心</el-menu-item>
            <el-menu-item index="6-12" class="menu_item"
              >我的优惠券</el-menu-item
            >
          </el-submenu>
          <el-menu-item index="2" class="menu_item">
            <span slot="title">下单必读</span>
          </el-menu-item>
          <el-menu-item index="3" class="menu_item">
            <span slot="title">操作指引</span>
          </el-menu-item>
          <el-menu-item index="4" class="menu_item">
            <span slot="title">联系方式</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="menu_h5_box">
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          mode="horizontal"
          menu-trigger="click"
          background-color="#ffffff"
          text-color="#000000"
          @select="toSelectMenu"
          popper-append-to-body
          :unique-opened="true"
        >
          <el-submenu index="1" class="menu_item" v-if="$store.state.userInfo">
            <template slot="title">
              <span>报价下单</span>
            </template>
            <el-menu-item index="1-1" class="menu_item"
              >合版不干胶</el-menu-item
            >
            <el-menu-item index="1-2" class="menu_item"
              >专版不干胶</el-menu-item
            >
            <el-menu-item index="1-3" class="menu_item">卷装标签</el-menu-item>
            <el-menu-item index="1-4" class="menu_item">特殊卷标</el-menu-item>
            <el-menu-item index="1-5" class="menu_item"
              >数码不干胶</el-menu-item
            >
          </el-submenu>
          <el-submenu index="6" class="menu_item" v-if="$store.state.userInfo">
            <template slot="title">
              <span>我的订单</span>
            </template>
            <el-menu-item index="6-1" class="menu_item">管理中心</el-menu-item>
            <el-menu-item index="6-2" class="menu_item">订单管理</el-menu-item>
            <el-menu-item index="6-3" class="menu_item">财务明细</el-menu-item>
            <el-menu-item index="6-4" class="menu_item">会员信息</el-menu-item>
            <el-menu-item index="6-5" class="menu_item"
              >授权书管理</el-menu-item
            >
            <el-menu-item index="6-6" class="menu_item"
              >发票抬头管理</el-menu-item
            >
            <!-- <el-menu-item index="6-7" class="menu_item">发票管理</el-menu-item> -->
            <el-menu-item index="6-8" class="menu_item">修改密码</el-menu-item>
            <el-menu-item index="6-9" class="menu_item">预存</el-menu-item>
            <el-menu-item index="6-0" class="menu_item">售后记录</el-menu-item>
            <el-menu-item index="6-11" class="menu_item">领券中心</el-menu-item>
            <el-menu-item index="6-12" class="menu_item"
              >我的优惠券</el-menu-item
            >
          </el-submenu>
          <el-menu-item index="2" class="menu_item_h5">
            <span slot="title">下单必读</span>
          </el-menu-item>
          <el-menu-item index="4" class="menu_item_h5">
            <span slot="title">联系方式</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="right">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
    <div class="null"></div>
    <Bottom></Bottom>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeMenu: "",
    };
  },
  created() {
    if(!this.$store.state.userInfo) {
      this.$router.push({
        name: "Home"
      })
    }
    if (this.$store.state.activeMenu) {
      this.activeMenu = this.$store.state.activeMenu;
    }
  },
  activated() {
    if (this.$store.state.activeMenu) {
      this.activeMenu = this.$store.state.activeMenu;
    }
  },
  methods: {
    toSelectMenu(index, indexPath) {
      this.$store.commit("UPDATE_ACTIVE_MENU", null);
      switch (index) {
        case "1-1":
        case "1-2":
        case "1-3":
        case "1-4":
        case "1-5":
          this.$router.push({
            name: "orderPage",
          });
          break;
        case "6-1":
          this.$router.push({
            name: "manegeCenter",
          });
          break;
        case "6-2":
          this.$router.push({
            name: "orderManege",
          });
          break;
        case "6-3":
          this.$router.push({
            name: "financeDetails",
          });
          break;
        case "6-4":
          this.$router.push({
            name: "personalInfo",
          });
          break;
        case "6-5":
          this.$router.push({
            name: "authentication",
          });
          break;
        case "6-6":
          this.$router.push({
            name: "invoiceTitle",
          });
          break;
        case "6-7":
          this.$router.push({
            name: "InvoiceManagement",
          });
          break;
        case "6-8":
          this.$router.push({
            name: "modifyPass",
          });
          break;
        case "6-9":
          this.$router.push({
            name: "prestorage",
          });
          break;
        case "6-0":
          this.$router.push({
            name: "after_sales_reasons",
          });
          break;
        case "6-11":
          this.$router.push({
            name: "couponList",
          });
          break;
        case "6-12":
          this.$router.push({
            name: "myCoupon",
          });
          break;
        case "2":
          this.$router.push({
            name: "orderDocument",
          });
          break;
        case "3":
          this.$router.push({
            name: "Operations",
          });
          break;
        case "4":
          this.$router.push({
            name: "contactWay",
          });
          break;
        default:
          break;
      }
      this.$store.commit("UPDATE_ACTIVE_MENU", index);
    },
    toHome() {
      this.$router.replace({
        name: "Home",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.other_page {
  width: 100%;
  height: 100%;
  overflow: scroll;
  position: absolute;
  padding-top: 30px;
  &::-webkit-scrollbar {
    width: 0.1rem;
    background-color: rgba(0, 0, 0, 0);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d4d4d4;
  }
  .head_box {
    position: fixed;
    top: 0;
  }
  @media screen and (min-width: 480px) {
    .login_box {
      margin: 10px 72px;
      display: flex;
      align-items: center;
      .logo {
        width: 200px;
        height: 80px;
        display: flex;
        align-items: center;
      }
      .img {
        width: 160px;
        cursor: pointer;
      }
    }
    .form_box {
      display: flex;
      align-items: center;
      margin-left: 20px;
      flex-wrap: wrap;
    }
    .main_box {
      display: flex;
      width: 100%;
      min-height: 100%;
      padding: 0 72px;
      box-sizing: border-box;
    }

    .banner_box {
      position: relative;
      width: 200px;
      // background: #00a0e9;
      .menu_box {
        width: 200px;
        height: 100%;
        background: #00a0e9;
        padding: 0;
        position: absolute;
        left: 200px;
        z-index: 10;
        overflow-y: scroll;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: rgba(0, 0, 0, 0);
        }

        &::-webkit-scrollbar-thumb {
          background-color: #d4d4d4;
        }
      }
    }
    .right {
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
    }
    .menu_h5_box {
      display: none;
    }
    .null {
      width: 100%;
      height: 100px;
    }
  }
  @media only screen and (max-width: 480px) {
    .login_box {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .logo {
        width: 200px;
        height: 80px;
        margin-left: 20px;
        display: flex;
        align-items: center;
      }
      .img {
        width: 160px;
        cursor: pointer;
      }
      .form_item {
        margin-bottom: 10px;
      }
    }
    .form_box {
      display: flex;
      margin-left: 20px;
      flex-wrap: wrap;
    }
    .main_box {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
    .right {
      width: 100%;
      height: 100%;
    }
    .banner_box {
      background: #00a0e9;
      display: none;
      /deep/.el-menu-vertical-demo {
        display: flex;
        background: #00a0e9;
      }
      .menu_box {
        width: 100%;
        background: #00a0e9;
        display: none;
      }
      .menu_h5_box {
        /deep/.el-dropdown-menu__item,
        .el-menu-item {
          padding: 0 20px;
        }
      }
      #banner {
        display: none;
      }
    }
  }
}
.alert-title span {
  animation: scale 2s infinite;
}
@keyframes scale {
  0%,
  100% {
    transform: scale(1);
    color: #ffffff;
    font-size: 13px;
  }
  50% {
    transform: scale(1.5);
    color: #f8f85a;
    font-size: 16px;
  }
}

.scale-text {
  animation: scale 4s infinite;
}
.information {
  height: 40px;
}
// /deep/.menu_item {
//   padding-left: 20px;
//   color: rgb(255, 255, 255);
//   background-color: #00a0e9;
// }
// /deep/.menu_item_h5 {
//   padding: 0 20px !important;
//   color: rgb(255, 255, 255);
//   background-color: #00a0e9;
// }
// .el-menu {
//   border-right: solid 1px #00a0e9;
// }
// .el-menu--horizontal {
//   flex-wrap: wrap;
// }
// .el-menu--horizontal > .el-menu-item.is-active {
//   color: #ffffff;
//   border-bottom: 2px solid #ffffff;
// }
// .el-menu--horizontal > .el-submenu .el-submenu__title {
//   color: #00a0e9 !important;
// }
// /deep/.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
// .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
// .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
//   background-color: #00a0e9 !important;
// }
// /deep/.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
// .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
// .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
//   background-color: #00a0e9 !important;
// }
// /deep/.el-submenu .el-submenu__title:hover {
//   background-color: #00a0e9 !important;
// }
// /deep/.el-submenu__title {
//   color: #ffffff !important;
//   background: #00a0e9;
// }
// /deep/.el-menu-item-group__title {
//   background: #00a0e9;
// }
// /deep/.el-submenu__title i {
//   color: #ffffff !important;
// }
</style>